var exports = {
  "E": "x04b3a21e--fe7f75--promotion-detail",
};

module.exports = exports;
